import { useMemo, useState } from "react";
import { titles } from "@/mocks/watchGuide";
import SectionHeading from "@/pages/home/components/SectionHeading";

const tabs = [
  { id: "all", label: "全部" },
  { id: "jp-drama", label: "日剧" },
  { id: "kr-drama", label: "韩剧" },
  { id: "jp-movie", label: "日影" },
  { id: "kr-movie", label: "韩影" },
];

export default function TitlesExplorer() {
  const [active, setActive] = useState("all");

  const filtered = useMemo(() => {
    if (active === "all") return titles;
    const lang = active.startsWith("jp") ? "日" : "韩";
    const type = active.endsWith("movie") ? "电影" : "剧集";
    return titles.filter((t) => t.lang === lang && t.type === type);
  }, [active]);

  return (
    <section id="titles" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="分类片单 · 本地筛选"
            title="按语种与类型挑一部，今晚就能开看"
            desc="下面这些作品在正版平台大多能找到中文字幕版本。用标签快速筛选，卡片给出的评分与看点仅作参考，不涉及任何下载或播放链接。"
          />
          <p className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">
            共 <span className="font-semibold text-foreground-950">{filtered.length}</span> 部作品
          </p>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-2">
          {tabs.map((t) => (
            <button
              key={t.id}
              onClick={() => setActive(t.id)}
              aria-pressed={active === t.id}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                active === t.id
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-700 border border-background-300/70 hover:border-primary-300"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {filtered.map((t) => (
            <article
              key={t.id}
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-900">
                <img
                  src={t.cover}
                  alt={`${t.title} 封面`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[11px] font-medium">
                  {t.lang}
                  {t.type === "电影" ? "影" : "剧"}
                </span>
                <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-black/60 text-background-50 text-[11px] flex items-center gap-0.5">
                  <i className="ri-star-fill text-[10px]"></i>
                  {t.rating}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 truncate">
                  {t.title}
                </h3>
                <p className="mt-1 text-[11px] md:text-xs text-foreground-500">
                  {t.year} · {t.type} · {t.genres.join(" / ")}
                </p>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {t.blurb}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-[11px] md:text-xs text-secondary-800">
                  <i className="ri-play-list-2-line"></i>
                  {t.availability}
                </span>
              </div>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="mt-10 text-center text-sm text-foreground-500">该分类下暂无作品。</p>
        )}
      </div>
    </section>
  );
}